__turbopack_context__.v({
  "button": "Button-module-scss-module__7y4cpq__button",
  "hyperlink": "Button-module-scss-module__7y4cpq__hyperlink",
  "link": "Button-module-scss-module__7y4cpq__link",
});
